var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",staticStyle:{"width":"75%"}},[(_vm.allEmployees.length)?_c('filter-bar',{attrs:{"filters":_vm.filterBarFilters},on:{"filterChange":_vm.filterChange},scopedSlots:_vm._u([{key:"inline",fn:function(){return [_c('field',{staticClass:"mr-4",attrs:{"label":"Compare:","col-class":"col-auto","params":{
				type: 'btn-group',
				buttons: [
					{ text: 'Date', value: 'date' },
					{ text: 'Costs', value: 'costs' },
					{ text: 'Quotes', value: 'quotes' },
				],
				disableNull: true
			}},model:{value:(_vm.tableLayout),callback:function ($$v) {_vm.tableLayout=$$v},expression:"tableLayout"}}),_c('field',{attrs:{"label":"View:","col-class":"col-auto","params":{
				type: 'btn-group',
				buttons: [
					{ text: 'Table', value: 'table' },
					{ text: 'Chart', value: 'chart' }
				],
				disableNull: true
			}},model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}})]},proxy:true}],null,false,1359500618)}):_vm._e(),(_vm.view == 'table')?_c('div',{staticClass:"justify-content-center"},[_c('table-list',{staticClass:"display-group",attrs:{"record-name":_vm.recordName,"records":_vm.mutatedUsers,"fields":_vm.tableFields,"sortable":true}})],1):_vm._e(),(_vm.view == 'chart')?_c('div',{staticClass:"justify-content-center mt-3"},[_c('service-report-chart-view',{attrs:{"users":_vm.mutatedUsers,"compare-by":_vm.tableLayout}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }